export const topInGroup = 10;
export const oneAbove = 1;
export const topMost = 120;
